import { api } from "@/shared/lib/api";
import { getApiErrorStatus } from "@/shared/api/error-handler";
import { z } from "zod";
import type { MatchSideVetoStateDto, MatchSideVetoPickRequest } from "../model/types";

const vetoStateSchema = z.object({
  matchId: z.string(),
  gameIndex: z.number().int(),
  pickerTeamId: z.string().nullable(),
  turnDeadlineUtc: z.string().datetime({ offset: true }).nullable(),
  status: z.string(),
  picks: z.array(
    z.object({
      gameIndex: z.number().int(),
      pickerTeamId: z.string(),
      side: z.string(),
      pickedAtUtc: z.string().datetime({ offset: true }),
    }),
  ),
  team1Id: z.string().nullable(),
  team2Id: z.string().nullable(),
});

const pickResultSchema = z.object({ success: z.boolean() });

export const matchVetoApi = {
  async getState(matchId: string): Promise<MatchSideVetoStateDto | null> {
    try {
      const response = await api.get<unknown>(`/matches/${matchId}/veto`);
      return vetoStateSchema.parse(response.data);
    } catch (error) {
      if (getApiErrorStatus(error) === 404) return null;
      throw error;
    }
  },

  async pickSide(matchId: string, request: MatchSideVetoPickRequest): Promise<{ success: boolean }> {
    const response = await api.post<unknown>(`/matches/${matchId}/veto/pick`, request);
    return pickResultSchema.parse(response.data);
  },
};
